export const INTERNAL_TRANSFER_STEPS = [
  { id: 0, label: "Destinatário", description: "CPF ou CNPJ" },
  { id: 1, label: "Transferência", description: "Valor e descrição" },
  { id: 2, label: "Confirmação", description: "Revise os dados" },
  { id: 3, label: "Senha", description: "Confirme com senha" },
  { id: 4, label: "Concluído", description: "Transferência finalizada" },
];
